import ReactSVG from 'react-svg';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';

import { getTemplates } from './PosterTemplate';
import RootStore from '../../../store/RootStore';

import './PosterBottom.scss';

interface IPosterBottom {
  rootStore?: RootStore;
  saveImg: () => void;
  diyTemplates: any[];
  templateId: number;
  setTemplateId: Dispatch<SetStateAction<number>>;
}

const Index = function (props: IPosterBottom) {
  const { diyTemplates } = props;
  const templates = getTemplates();
  const [allTemplates, setAllTemplates] = useState([] as any[]);

  useEffect(() => {
    setAllTemplates([
      ...diyTemplates,
      //  只保留第二个和第三个模板
      ...templates.filter((_, index) => [1, 2].includes(index)),
    ]);
  }, [diyTemplates]);

  return (
    <div className="poster-bottom">
      <div className="poster-style-list">
        {allTemplates.map((tmp) => (
          <div
            className="one every-one-template"
            key={tmp.id}
            onClick={() => props.setTemplateId(tmp.id)}
          >
            {Number(tmp.id) >= 1000 ? (
              <img
                src={tmp.src}
                className={classNames('icon-template', {
                  active: tmp.id === props.templateId,
                })}
              />
            ) : (
              <ReactSVG
                src={tmp.src}
                className={classNames('icon-template', {
                  active: tmp.id === props.templateId,
                })}
              />
            )}
          </div>
        ))}
      </div>
      <div className="operation">
        <div className="buttons">
          <a onClick={props.saveImg}>{intl.get('Make')}</a>
        </div>
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(Index));
